// extracted by mini-css-extract-plugin
export default {"redBorder":"paperMatrixQues_redBorder__A8Cq6","greenBorder":"paperMatrixQues_greenBorder__8FEGZ"};